module.exports = __webpack_public_path__ + "static/media/hamburgerMenuLightBlue.7370a473.svg";